/**
 * Resolve string max length from an AttributeDef-like shape.
 * Accepts `props.length` (ConfigObject) or top-level `length` (legacy EntityForm).
 */
export function resolveAttrMaxLength(
  attr:
    | { props?: Record<string, unknown> | null; length?: unknown }
    | null
    | undefined,
): number | undefined {
  if (!attr) return undefined
  const raw = attr.props?.length ?? attr.length
  const n = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(n) || n <= 0) return undefined
  return Math.floor(n)
}

/** Truncate a string value to the attribute's max length (no-op when unset). */
export function clampToAttrMaxLength(
  attr: { props?: Record<string, unknown> | null; length?: unknown } | null | undefined,
  value: string,
): string {
  const max = resolveAttrMaxLength(attr)
  if (max == null || value.length <= max) return value
  return value.slice(0, max)
}
